import React, { useState, useEffect } from 'react';
import './ConnectionStatus.css';
import { useWebSocket } from '../contexts/WebSocketContext';

const ConnectionStatus: React.FC = () => {
  const { isConnected } = useWebSocket();
  const [displayStatus, setDisplayStatus] = useState(isConnected);
  const [isReconnecting, setIsReconnecting] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isConnected) {
      // Immediately show connected status
      setDisplayStatus(true);
      setIsReconnecting(false);
    } else {
      // Delay showing offline status by 2 seconds to avoid flicker during reconnection
      setIsReconnecting(true);
      timeoutId = setTimeout(() => {
        setDisplayStatus(false);
        setIsReconnecting(false);
      }, 2000);
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isConnected]);

  return (
    <div className="connection-status">
      <span className={`status-indicator ${displayStatus ? 'connected' : isReconnecting ? 'reconnecting' : 'disconnected'}`}></span>
      <span className="status-text">
        {displayStatus ? 'Live' : isReconnecting ? 'Reconnecting...' : 'Offline'}
      </span>
    </div>
  );
};

export default ConnectionStatus;